import { render, staticRenderFns } from "./HomeSchoolFrame.vue?vue&type=template&id=2b693a6b&scoped=true&class=homeSchool-home&"
import script from "./HomeSchoolFrame.vue?vue&type=script&lang=js&"
export * from "./HomeSchoolFrame.vue?vue&type=script&lang=js&"
import style0 from "./HomeSchoolFrame.vue?vue&type=style&index=0&id=2b693a6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b693a6b",
  null
  
)

export default component.exports